import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { DataStateChangeEvent } from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor, FilterDescriptor } from "@progress/kendo-data-query";
import { AppService } from "../../../app.service";
import { ListPageBase } from "../../../shared/components/list-page-base/list-page-base";
import { KeyValueObject } from "../../../shared/models/core/KeyValueObject";
import { GridSettings } from "../../../shared/models/grid/grid-settings";
import { ServiceCenterListItem } from "../../../shared/models/service-center/service-center-list-item";
import { ExportExcelFromGridService } from "../../../shared/services/export-excel-from-grid.service";
import { LookupService } from "../../../shared/services/lookup.service";
import { ServiceCentersService } from "../../../shared/services/service-centers.service";
import { StatePersistingService } from "../../../shared/services/state-persisting.service";

@Component({
	selector: 'service-centers-list',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss']
})
export class ServiceCentersListPage extends ListPageBase<ServiceCenterListItem> {

	nameFilter: string = '';
	parentServiceCenterId: number = null;
	serviceCenterTypeId: number = null;

	parentServiceCenters: KeyValueObject[] = [];
	serviceCenterTypes: KeyValueObject[] = [];

	parentDefaultItem: KeyValueObject = { id: null, name: 'Все' } as KeyValueObject;
	typeDefaultItem: KeyValueObject = { id: null, name: 'Все' } as KeyValueObject;

	public gridSettings: GridSettings = {
		state: {
			skip: 0,
			take: 100,
			sort: [{ field: 'name', dir: 'asc' }],
			filter: { logic: 'and', filters: [] },
		},
		columnsConfig: [
			{
				orderIndex: 0,
				field: 'name',
				title: 'Наименование СЦ',
				filter: 'string',
				filterable: false,
				width: 280,
				hidden: false
			},
			{
				orderIndex: 1,
				field: 'address',
				title: 'Адрес',
				filter: 'string',
				filterable: false,
				width: 320,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'parentServiceCenterName',
				title: 'Родительский СЦ',
				filter: 'string',
				filterable: false,
				width: 250,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'serviceCenterTypeName',
				title: 'Тип СЦ',
				filter: 'string',
				filterable: false,
				width: 220,
				hidden: false
			}
		]
	};

	constructor(
		protected appService: AppService,
		protected router: Router,
		protected dataService: ServiceCentersService,
		protected persistingService: StatePersistingService,
		protected exportExcelFromGridService: ExportExcelFromGridService,
		private lookupService: LookupService)
	{
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		appService.pageTitle = 'Сервисные центры';
	}

	onListPageInit(): void {
		this.lookupService.getData('service-centers', null).subscribe(data => {
			this.parentServiceCenters = (data || []).filter(x => !x.skipInventory);
		});
		this.lookupService.getData('service-center-types', null).subscribe(data => {
			this.serviceCenterTypes = data || [];
		});
	}

	processListItems(items: ServiceCenterListItem[]): void {
	}

	public cellClick({ dataItem }: any): void {
		this.router.navigate(['/categories/service-center', dataItem.serviceCenterId]);
	}

	public dataStateChange(state: DataStateChangeEvent): void {
		state.filter = this.gridSettings.state.filter;
		super.dataStateChange(state);
	}

	applyFilters(): void {
		const filters: FilterDescriptor[] = [];

		if (this.nameFilter && this.nameFilter.trim()) {
			filters.push({ field: 'name', operator: 'contains', value: this.nameFilter.trim() });
		}

		if (this.parentServiceCenterId) {
			filters.push({ field: 'parentServiceCenterId', operator: 'eq', value: this.parentServiceCenterId });
		}

		if (this.serviceCenterTypeId) {
			filters.push({ field: 'serviceCenterTypeId', operator: 'eq', value: this.serviceCenterTypeId });
		}

		this.gridSettings.state.filter = { logic: 'and', filters: filters } as CompositeFilterDescriptor;
		this.gridSettings.state.skip = 0;
		this.loadData();
	}

	clearFilters(): void {
		this.nameFilter = '';
		this.parentServiceCenterId = null;
		this.serviceCenterTypeId = null;
		this.applyFilters();
	}
}
